import SearchAndSelect from "../SearchAndSelect";
import { useQuery } from "react-query"
import { reasonsRequestsFn } from "../../../services/reasonsRequest";

// O segmento vem do cliente do atendimento (tb_clients.type_client). Cliente Ponto só
// enxerga tipo Ponto, Automação só Automação, e quem não tem classificação vê a lista
// inteira. O tipo de atendimento sem segmento (tb_frequent_requests.type NULL) aparece
// sempre: é o caso de "Ligação de pós atendimento", que não é de nenhum dos dois.
// O que já está selecionado também nunca some, senão editar um atendimento antigo de
// outro segmento deixaria o campo em branco e o atendente perderia a referência.
const ReasonsRequestSelect = ({ formik, name, setValue, value, error, helpText, segment }) => {
    const { data, isLoading } = useQuery(["reasons-requests-list"], () => reasonsRequestsFn({}));
    const selectedId = formik ? formik.values[name] : value;
    const reasons = data?.filter((i) => !segment || !i.type || i.type === segment || i.id === selectedId)
                         .map((i) => ({ label: i.description, value: i.id }));

    const handleSelectOption = async (id) => {
        const item = await data.find((i) => i?.id === id);
        setValue(item);
    };

    return <SearchAndSelect 
                name={name} 
                setValue={handleSelectOption} 
                value={value} 
                placeholder="Selecione uma opção" 
                label={"Tipo de Atendimento"} 
                options={reasons || []} 
                formik={formik} 
                loading={isLoading} 
                fullWidth
                className="mt-2 mb-2"
                error={error}
                helpText={helpText}
            />
};
  

export default ReasonsRequestSelect;